import { useCallback, useMemo } from 'react';
import { IConfigNetBroker } from '../../config';

export type MarketTranslation = {
  nasdaq: string;
  nyse: string;
  frankfurt: string;
  xetra: string;
  wien: string;
  bet: string;
  beta: string;
  xtend: string;
  london: string;
  otc: string;
};

export type UseMarketProps = {
  translation: {
    markets: MarketTranslation;
  };
  marketsConfig: IConfigNetBroker['Markets']['markets'];
};

export const useMarketsCommon = ({ translation, marketsConfig }: UseMarketProps) => {
  const getMicName = useCallback(
    (mic: string) => {
      const markets = new Map();

      marketsConfig.nasdaq.forEach(mic => markets.set(mic, translation.markets.nasdaq));
      marketsConfig.nyse.forEach(mic => markets.set(mic, translation.markets.nyse));
      marketsConfig.frankfurt.forEach(mic => markets.set(mic, translation.markets.frankfurt));
      marketsConfig.xetra.forEach(mic => markets.set(mic, translation.markets.xetra));
      marketsConfig.wien.forEach(mic => markets.set(mic, translation.markets.wien));
      marketsConfig.bet.forEach(mic => markets.set(mic, translation.markets.bet));
      marketsConfig.beta.forEach(mic => markets.set(mic, translation.markets.beta));
      marketsConfig.xtend.forEach(mic => markets.set(mic, translation.markets.xtend));
      marketsConfig.london.forEach(mic => markets.set(mic, translation.markets.london));
      marketsConfig.otc.forEach(mic => markets.set(mic, translation.markets.otc));

      return markets.get(mic) || mic;
    },
    [marketsConfig, translation],
  );

  return useMemo(
    () => ({
      getMicName,
    }),
    [getMicName],
  );
};
